let tenant_name = 'nimble';

export const apiUrl = `https://dev-api.itstaste.com/api`;
export const defaultPagination =  `${process.env.VUE_APP_DEFAULT_PAGINATION}`;
export const perPageList =  [20, 50, 100];

export const APP_NAME = 'nimble';
export const APP_PORTAL = 'supplier';
export const APP_TENANT = tenant_name;


// // export const apiUrl = `http://${tenant_name}.localhost:8000/api`;
// export const apiUrl = `https://${tenant_name}.dev-api.itstaste.com/api`;
// export const defaultPagination = 10;


